var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextBlock',_vm._b({staticClass:"playhera-label secondary-font",class:{
    'required h-pr-4': _vm.required,
    'registration-form-style': _vm.$route.path.includes('registration/form'),
  }},'TextBlock',Object.assign({}, _vm.additionalParams,
    {size: _vm.$options.fontSize,
    lineHeight: 1.2,
    text: _vm.text}),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }